var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.actions),function(item,i){return _c('div',{key:i},[_c('v-btn',{staticClass:"md:flex justify-start w-full",attrs:{"text":""},on:{"click":_vm.move}},[_vm._v(" "+_vm._s(item.action)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }